module.exports = __webpack_public_path__ + "static/media/Knizeci_vrch.2556735e.md";